<template>
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="pink-checkmark-title"
  >
    <path
      d="M5.64154 11.0431L15.4232 0.955782C15.9999 0.361054 16.9495 0.346444 17.5442 0.923151C18.139 1.49986 18.1536 2.44949 17.5769 3.04422L5.54031 15.4569L0.376425 9.61833C-0.172408 8.99779 -0.114276 8.04982 0.506267 7.50099C1.12681 6.95215 2.07478 7.01029 2.62361 7.63083L5.64154 11.0431Z"
      fill="#FF0064"
    />
    <title id="pink-checkmark-title">{{ title }}</title>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PinkCheckmark',
  props: {
    title: {
      type: String,
      default: 'is available',
    },
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 16,
    },
  },
};
</script>
